import React from "react";
import { SvgIcon } from "./SvgIcon";
var smallPath = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "radio-outline",
  stroke: "currentColor",
  strokeWidth: "1.5",
  cx: "10",
  cy: "10",
  r: "9.25"
}), /*#__PURE__*/React.createElement("circle", {
  className: "radio-fill",
  fill: "currentColor",
  cx: "10",
  cy: "10",
  r: "5"
})));
var paths = {
  s: smallPath,
  m: smallPath,
  l: smallPath
};
export var RadioIcon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    paths: paths
  }, props));
});
RadioIcon.displayName = "Radio";